/**
 * Which side the user is playing. It is not a property of a board — My Games filters its statistics
 * by it and the repertoire is read from it — so it stays here while the boards themselves live in
 * `boards.<id>` (state/slices/boards.ts).
 */
export const boardSlice = {
    userSide: 'white', // "white" | "black"
};
